export default "__VITE_ASSET__5c284d9d__"